<script lang="ts" setup>
	defineProps<{
		show: boolean
		title?: string
	}>()

	defineEmits<{
		(event: 'update:show', arg: boolean): void
	}>()
	const { openInterCom } = useIntercom()
</script>

<template>
	<dialogs-error
		:name="title || 'Pause Activaion'"
		:show="show"
		type="warning"
		wrapper-class="bg-gray-50 px-4 py-8 rounded-md w-full space-y-5"
		header="Unable To Activate"
		@close="$emit('update:show', false)"
	>
		<template #icon>
			<div>
				<lazy-tools-icon dir="fill" icon="failure" />
			</div>
		</template>
		<template #paragraph>
			<p class="font-medium tracking-wide text-gray-500">
				<slot name="note">
					You are unable to activate the plan for this staff at the moment. <br />
					<br />
					If you have any questions or need assistance, please reach out to our customer support team. <br />
					<br />
					Alternatively, you can ask the staff member to initiate the activation process on their end <br />
				</slot>
			</p>
		</template>
		<template #button>
			<div class="flex w-full flex-col gap-y-2">
				<a-button
					class="default-btn 00 w-full justify-center !bg-primary-2 font-semibold tracking-wide !text-white disabled:!bg-primary-2"
					data-test="Noted"
					@click="$emit('update:show', false)"
				>
					Noted
				</a-button>

				<button
					type="button"
					name="customer support"
					class="default-btn w-full justify-center text-center font-semibold text-primary-2"
					@click="openInterCom"
				>
					Contact Support
				</button>
			</div>
		</template>
	</dialogs-error>
</template>
